import request from '../../shared/request'

export function login({ email, password, remember }) {
  return request(`/login`, {
    method: 'POST',
    body: JSON.stringify({
      email,
      password,
      remember,
      loggingTo: 'app-aluno'
    })
  })
}

export function forgot(email) {
  return request(`/v1/generate-password`, {
    method: 'POST',
    body: JSON.stringify({ email: email })
  })
}

export function selectOrganization({ organizationId, clientType, deviceUniqueId }) {
  return request(`/connect`, {
    method: 'POST',
    body: {
      organization: organizationId,
      device: `${clientType}:${deviceUniqueId}`
    }
  })
}
